// extracted by mini-css-extract-plugin
module.exports = {"wapperBtn":"wapperBtn--14aaR"};